import {
  Chiron,
  Earth,
  Jupiter,
  Mars,
  Mercury,
  Moon,
  Neptune,
  NorthNode,
  Pluto,
  Saturn,
  SouthNode,
  Sun,
  Uranus,
  Venus,
} from "./constants";

export const Planets: {
  all: string[];
} = {
  all: [
    Sun,
    Earth,
    NorthNode,
    SouthNode,
    Moon,
    Mercury,
    Venus,
    Mars,
    Jupiter,
    Saturn,
    Uranus,
    Neptune,
    Pluto,
    Chiron,
  ],
};
